
export class DOMHelper {
	/*
	static getElementScale2(el: HTMLElement): any[] {
		var array:any [] = [];
		// var scale:number = 1;
		while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
			var elementScale:number = DOMHelper.getElementTransformScale(el);
			// scale *= elementScale;
			array.push(el.className, elementScale, "("+ el.style.transform +")");
			el = <HTMLElement> el.offsetParent;
		}
		return array;
	}

	*/

	static getElementScale(el: HTMLElement): any {
		var scale: number = 1;
		while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
			var elementScale: number = DOMHelper.getElementTransformScale(el);
			scale *= elementScale;
			el = <HTMLElement>el.offsetParent;
		}
		return scale;
	}

	static getElementTransformScale(el: HTMLElement) {
		if (el.style.transform) {
			var match: any = /scale\((.*?)\)/.exec(el.style.transform);
			if (match) return parseFloat(match[1]);
		}
		return 1;
	}

	static getElementTransformRotate(el: HTMLElement) {
		if (el.style.transform) {
			var match: any = /rotate\((.*?)\)/.exec(el.style.transform);
			if (match) return parseFloat(match[1]);
		}
		return 0;
	}


	static getElementTransform3D(el: HTMLElement): any {
		var scale: number = 1;
		var x: number = 1;
		var y: number = 1;
		var z: number = 1;
		let rotate: string = '0deg';
		if (el.style.transform) {
			var match: any;
			match = /scale\((.*?)\)/.exec(el.style.transform);
			if (match) {
				scale = parseFloat(match[1]);
			}
			match = /translate3d\((.*?)\,(.*?)\,(.*?)\)/.exec(el.style.transform);
			if (match) {
				x = parseFloat(match[1]);
				y = parseFloat(match[2]);
				z = parseFloat(match[3]);
			}
			match = /rotate\((.*?)\)/.exec(el.style.transform);
			if (match) {
				rotate = match[1];
			}
		}
		return {
			x: x,
			y: y,
			z: z,
			scale: scale,
			rotate: rotate
		};
	}

	static getElementTranslate(el: HTMLElement): { x: number, y: number } {
		const computed = window.getComputedStyle(el);
		const transform = computed.transform;
		if (!transform || transform === 'none') {
			return { x: 0, y: 0 };
		}
		const match = transform.match(/matrix.*\((.+)\)/);
		if (!match) return { x: 0, y: 0 };
		const values = match[1].split(',').map(v => parseFloat(v.trim()));
		return {
			x: values[4] || 0,
			y: values[5] || 0
		};
	}

	static getHTMLElement(item: any, defaultElement: HTMLElement): HTMLElement {
		if (item) {
			if (typeof item == "string") {
				var element: HTMLElement = document.querySelector(item);
				if (element) return element;
			} else if (item instanceof HTMLElement) {
				return item;
			}
		}
		return defaultElement;
	}
	static getLocalPoint(el, globalPoint) {
		var position: any = DOMHelper.getDOMGlobalPosition(el);

		var x = (globalPoint.x - position.left) / position.scale; //x position within the element.
		var y = (globalPoint.y - position.top) / position.scale;  //y position within the element.
		return {
			scale: position.scale,
			gp: globalPoint,
			x: x,
			y: y
		};
	}
	static getDOMGlobalPosition(el): any {
		let accumZoom = 1;
		if (el.className.indexOf('zoomed') > -1) {
			accumZoom = this.getAccumulatedZoom(el);
		}
		var rect = el.getBoundingClientRect();
		var _scale: number = 1;
		if (el.className.indexOf('notScaled') == -1) {
			while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
				var scale: number = DOMHelper.getElementTransformScale(el);
				_scale *= scale;
				el = el.offsetParent;
			}
		}
		_scale = _scale * accumZoom;
		return { left: rect.x, top: rect.y, scale: _scale };
	}

	// rotation not support
	// convert global rectangle to target layer coordinates
	static convertGRect(gRect: DOMRect, targetLayer: HTMLElement): any {
		var pt1: any = DOMHelper.getLocalPoint(targetLayer, gRect);
		var pt2: any = DOMHelper.getLocalPoint(targetLayer, { x: gRect.x + gRect.width, y: gRect.y + gRect.height });
		return { gRect: gRect, x: pt1.x, y: pt1.y, width: pt2.x - pt1.x, height: pt2.y - pt1.y };
	}

	static removeChildren(container: HTMLElement): void {
		while (container.childNodes.length) {
			var child: ChildNode = container.childNodes[0];
			container.removeChild(child);
		};
	}
	static removeElement(element: HTMLElement): void {
		if (element && element.parentElement) {
			element.parentElement.removeChild(element);
		}
	}

	static findROComDOM(element: HTMLElement): HTMLElement {
		while (element && !element.classList.contains("ro-component"))
			element = element.parentElement;

		return element;
	}

	static getAccumulatedZoom(element) { //慎用: 因loop到root ele, 或會變慢
		// 基本情况：如果没有父元素，返回 1（无缩放）
		if (!element) {
			return 1;
		}

		// 获取当前元素的计算样式
		const style = window.getComputedStyle(element);

		// 获取当前元素的 zoom 值，默认为 1
		const zoom = parseFloat(style.zoom) || 1;

		// 递归查找父元素并计算总的 zoom
		return zoom * this.getAccumulatedZoom(element.parentElement);
	}

	static truncateStringMiddle(
		str: string,
		maxWidth: number,
		ngStyle: { [key: string]: string | number }
	): string {
		// 边界处理：字符串为空、长度≤4 或 最大宽度≤0，直接返回
		if (!str || str.length <= 4 || maxWidth <= 0) return str;

		// 1. 创建临时测量元素（测量后自动移除，避免污染DOM）
		const measureElement = document.createElement('span');
		measureElement.style.cssText = `
    visibility: hidden;
    position: absolute;
    white-space: nowrap;
    pointer-events: none;
    left: -9999px;
    top: -9999px;
  `;

		// 2. 应用ngStyle到测量元素（支持Angular驼峰属性和CSS标准属性）
		Object.entries(ngStyle).forEach(([key, value]) => {
			const cssKey = key.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
			measureElement.style[cssKey as any] = value.toString();
		});

		// 3. 插入到DOM（否则无法测量offsetWidth）
		document.body.appendChild(measureElement);

		try {
			// 测量原始字符串宽度：未超宽直接返回
			measureElement.textContent = str;
			const originalWidth = measureElement.offsetWidth;
			if (originalWidth <= maxWidth) return str;

			// 4. 固定保留末尾4字符和中间省略号
			const suffix = str.slice(-4);
			const ellipsis = '...';
			const reservedText = `${ellipsis}${suffix}`;

			// 测量保留部分的宽度：极端情况（保留部分已超宽）直接返回保留部分
			measureElement.textContent = reservedText;
			const reservedWidth = measureElement.offsetWidth;
			if (reservedWidth >= maxWidth) return reservedText;

			// 5. 计算开头可保留的最大宽度
			const maxPrefixWidth = maxWidth - reservedWidth;

			// 6. 二分法查找开头最大可保留长度（高效精确）
			let left = 0;
			let right = str.length - 4; // 开头长度上限（总长度 - 末尾4字符）
			let bestPrefixLength = 0;

			while (left <= right) {
				const mid = Math.floor((left + right) / 2);
				const prefix = str.slice(0, mid);
				measureElement.textContent = prefix;
				const prefixWidth = measureElement.offsetWidth;

				if (prefixWidth <= maxPrefixWidth) {
					bestPrefixLength = mid;
					left = mid + 1;
				} else {
					right = mid - 1;
				}
			}

			// 7. 拼接最终结果
			const prefix = str.slice(0, bestPrefixLength);
			return `${prefix}${ellipsis}${suffix}`;
		} finally {
			// 确保无论是否出错，都移除临时元素（避免DOM污染）
			if (measureElement.parentNode) {
				measureElement.parentNode.removeChild(measureElement);
			}
		}
	}

}